import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { Heading } from 'scouting-ui/lib';

import { Collapse } from '../bsaComponents';
import styles from './TableFilterPanel.less';

const { Panel } = Collapse;

class TableFilterPanel extends React.Component {
  render() {
    const { header, children, className, mobileOnly, padding, ...rest } =
      this.props;

    return (
      <Panel
        {...rest}
        className={cn(className, styles.panel, {
          [styles.mobileOnly]: mobileOnly,
          [styles.noPadding]: !padding,
        })}
        header={<Heading font="display-h5">{header}</Heading>}
      >
        {children}
      </Panel>
    );
  }
}

TableFilterPanel.propTypes = {
  ...Panel.propTypes,
  mobileOnly: PropTypes.bool,
  padding: PropTypes.bool,
};

TableFilterPanel.defaultProps = {
  forceRender: true,
};

export default TableFilterPanel;
